import { differenceInMinutes } from "date-fns";
import { getSuggestedMealEventsForMealPlanEvents } from "@notemeal/meal-plan-suggestions-core";
import { getMealPlanEventsForTemplatesOnDate } from "./utils";
import { logger } from "@notemeal/server-log";
/*
 * Given a list of calendar events for mealPlan and external events returns a list of suggested meal events.
 *
 * (Used in dietitian calendar preview)
 */
export const getSuggestedMealEventsForCalendarEvents = ({ mealPlanEvents, externalEvents, modifiedMealTemplateIds, }) => {
    try {
        const suggestions = getSuggestedMealEventsForMealPlanEvents({ mealPlanEvents, externalEvents, modifiedMealTemplateIds }).map(e => {
            return {
                id: e.id,
                oldId: e.oldId,
                oldStart: e.oldStart,
                start: e.start,
                durationInMinutes: e.durationInMinutes,
                name: e.name,
                isAllDay: e.isAllDay,
            };
        });
        return suggestions;
    }
    catch (e) {
        logger.error({
            type: "misc",
            message: `Error in getSuggestedMealEventsForMealPlanEvents: ${String(e)}`,
        });
        return [];
    }
};
/*
 * For a list of external events and meal and activity templates returns a suggested meal plan schedule.
 *
 * (Used in athlete flow)
 */
export const getSuggestedMealEventsForTemplatesOnDate = (date, externalEvents, mealTemplates, activityTemplates, modifiedMealTemplateIds) => {
    const mealPlanEvents = getMealPlanEventsForTemplatesOnDate(date, mealTemplates, activityTemplates);
    try {
        const suggestions = getSuggestedMealEventsForMealPlanEvents({
            mealPlanEvents,
            externalEvents: externalEvents.map(event => {
                return {
                    ...event,
                    __typename: "external",
                    start: event.startDate,
                    durationInMinutes: differenceInMinutes(event.endDate, event.startDate),
                };
            }),
            modifiedMealTemplateIds,
        });
        return suggestions;
    }
    catch (e) {
        logger.error({
            type: "misc",
            message: `Error in getSuggestedMealEventsForTemplatesOnDate: ${String(e)}`,
        });
        return [];
    }
};
//# sourceMappingURL=MealPlanSuggestionsService.js.map